var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// import { EventCenterForMicroApp } from '@micro-zoe/micro-app'
import { Log } from '@mamba/clients';
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import Vue from 'vue';
let MicroMiddleware = class MicroMiddleware {
    constructor() {
        if (!this.isMicro) {
            return;
        }
        // 补全路径
        __webpack_public_path__ = window.__MICRO_APP_PUBLIC_PATH__;
        // 获取引用数据
        this.AppData = lodash.defaultTo(lodash.result(window.microApp, 'getData'), {});
        // 获取全局数据
        this.GlobalData = lodash.defaultTo(lodash.result(window.microApp, 'getGlobalData'), {});
        this.rewriteConfig();
        // this.rewriteRouter();
        this.addListener();
        console.log('');
        console.log('');
        Log.success(` ------【 Micro 加载 ${window.__MICRO_APP_NAME__} 】------ `, window, this);
        console.log('');
        console.log('');
    }
    get isMicro() {
        return window.__MICRO_APP_ENVIRONMENT__;
    }
    get MicroAppName() {
        return window.__MICRO_APP_NAME__;
    }
    get MicroApp() {
        return window.microApp;
    }
    /**
     * 基座路由
     * @readonly
     * @memberof MicroMiddleware
     */
    get $router() {
        return lodash.get(this.GlobalData, '$router');
    }
    // get WeixinJSBridge() {
    //   return lodash.get(this.GlobalData, 'WeixinJSBridge');
    // }
    /**
     * AjaxBasics 配置
     * @readonly
     * @type {(Pick<typeof AjaxBasics, 'onEnd' | 'onEndAll' | 'onError' | 'onStart' | 'merge'>)}
     * @memberof MicroMiddleware
     */
    get AjaxBasics() {
        return lodash.get(this.GlobalData, 'AjaxBasics', {});
    }
    eqBasePath() {
        return lodash.includes(lodash.toLower(lodash.trim(window.location.pathname, '/')), lodash.toLower(lodash.trim(window.__MICRO_APP_BASE_ROUTE__, '/')));
    }
    /**
     * 执行路由
     * @param {('push' | 'replace' | 'back')} action
     * @param {*} [location]
     * @memberof MicroMiddleware
     */
    resultRouter(action, location) {
        if (lodash.isObject(location)) {
            const menuType = lodash.get(location.location, 'menuType');
            // 转换 路由为基座路由
            // if (lodash.eq(String(menuType), EnumMicroAppType.Platform)) {
            //   location.href = lodash.replace(location.href, '#', EnumMicroApp.Protal);
            // }
            location = lodash.assign({}, location, this.AppData);
        }
        lodash.invoke(this.$router, action, location);
    }
    /**
     * 重写配置信息
     * @return {*}
     * @memberof MicroMiddleware
     */
    rewriteConfig() {
        const { AppData } = this;
        // 路由变更 hash
        lodash.merge(window.__NUXT__, {
            config: {
                // 改变路由模式 https://micro-zoe.github.io/micro-app/docs.html#/zh-cn/route
                getRouterOptions(options) {
                    // 哈希模式 不需要
                    options.base = window.__MICRO_APP_BASE_ROUTE__ || '/';
                    // options.mode = 'hash';
                    const basePage = new URL(window.__MICRO_APP_PUBLIC_PATH__);
                    // 加载微应用组件
                    if (basePage.pathname) {
                        const component = lodash.find(options.routes, [
                            'name',
                            lodash.trim(basePage.pathname, '/'),
                        ]);
                        if (component) {
                            // 清理现有首页
                            lodash.remove(options.routes, ['name', 'index']);
                            options.routes.unshift({
                                ...component,
                                path: '/',
                                name: 'index',
                            });
                        }
                    }
                    Log.info('【 Micro RouterOptions 】', options);
                    return options;
                },
                // _app: {
                //     mode: 'hash',
                //     basePath: window.__MICRO_APP_BASE_URL__,
                // }
            },
        });
    }
    /**
     * 绑定事件
     * @memberof MicroMiddleware
     */
    addListener() {
        /**
         * 绑定监听函数
         * dataListener: 绑定函数
         * autoTrigger: 在初次绑定监听函数时有缓存数据，是否需要主动触发一次，默认为false
         */
        window.microApp.addGlobalDataListener((data) => {
            Log.info('【 Micro 全局数据 】', data);
        }, true);
        // window.microApp.addDataListener((options: INextDataOptions) => {
        //   try {
        //     if (lodash.eq(options.type, EnumMicroNoticeType.RouteChange)) {
        //       const path = lodash.trim(options.data.hash, '#') || '/';
        //       const RawLocation = window.$nuxt.$router.resolve({
        //         path,
        //         query: options.data.query,
        //       }).location;
        //       Log.info(
        //         '【 Micro Data 】',
        //         options,
        //         window.$nuxt.$route,
        //         RawLocation,
        //       );
        //       if (
        //         lodash.isEqual(
        //           lodash.pick(window.$nuxt.$route, ['path', 'query']),
        //           RawLocation,
        //         ) ||
        //         lodash.eq(window.$nuxt.$route.fullPath, path)
        //       ) {
        //         return Log.warning('【 Micro 重复路由 】');
        //       }
        //       window.$nuxt.$router.replace(RawLocation);
        //     }
        //   } catch (error) {}
        // });
    }
};
MicroMiddleware = __decorate([
    BindAll()
], MicroMiddleware);
export const Micro = new MicroMiddleware();
lodash.set(Vue, '$Micro', Micro);
Object.defineProperty(Vue.prototype, '$Micro', {
    get: lodash.constant(Micro),
});
